/*
	STORE

	* cleaner modules: https://dev.to/simo_benhida/tip---import-vuejs-modules-at-once-58dl
*/
//------------------------------------------------------------
// IMPORTS
//------------------------------------------------------------

import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import gameData from './gameData/';
import gameOS from './gameOS/';
import player from './player/';

//------------------------------------------------------------
// EXPORT
//------------------------------------------------------------

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
	modules: {
		gameData,
		gameOS,
		player,
	},
	// plugins: [createPersistedState({
	// 	key: 'Kleptobreaker'
	// })],
	// 02.02.18 - 'mutations outside' error when dev tools time travelling
	// strict: debug, // uncomment if performance degrades
});